// extracted by mini-css-extract-plugin
module.exports = {"link":"WorkspaceHome--link--25xEh"};